module.exports = __webpack_public_path__ + "static/media/05.92f5c9d2.jpg";